var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 11c0-4.969 4.031-9 9-9s9 4.031 9 9-4.031 9-9 9a9.4 9.4 0 0 1-2.025-.225 1 1 0 0 0-.931.269L16.087 22H13c-.55 0-1 .45-1 1v3H9c-.55 0-1 .45-1 1v3H2v-5.087l10.175-10.175c.262-.263.356-.657.244-1.013A9 9 0 0 1 12 10.994zm9-11c-6.075 0-11 4.925-11 11 0 .944.119 1.863.344 2.744L.294 23.794A1 1 0 0 0 0 24.5V31c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-3h3c.55 0 1-.45 1-1v-3h2.5c.262 0 .519-.106.706-.294l1.875-1.875q.936.17 1.919.169c6.075 0 11-4.925 11-11S27.075 0 21 0m2 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export default SvgKey;